import { render, staticRenderFns } from "./CompanyDetails.vue?vue&type=template&id=3de65c8a&scoped=true"
import script from "./CompanyDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./CompanyDetails.vue?vue&type=script&setup=true&lang=js"
import style0 from "./CompanyDetails.vue?vue&type=style&index=0&id=3de65c8a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3de65c8a",
  null
  
)

export default component.exports